




































import { Vue, Component, Prop, Model } from "vue-property-decorator";
import { appDrawerModule } from "@/app-drawer/modules";
import * as _ from "lodash";
import { authModule } from "../auth/modules";
import Router from "@/router";

@Component({
    name: "Drawer"
})
export default class Drawer extends Vue {
    get isOpen() {
        return appDrawerModule.isOpen;
    }

    set isOpen(value) {
        appDrawerModule.updateDrawer(value);
    }

    get profile() {
        const auth = authModule.item;
        return auth ? auth.profile : null;
    }

    private logIn(): void {
        const currentPath = this.$route.fullPath;
        authModule.logIn(currentPath);
    }

    private logOut(): void {
        authModule.logOut();
    }

    private navigateTo(path: string): void {
        Router.push(path);
    }
}
